import { render, staticRenderFns } from "./InputPad.vue?vue&type=template&id=c9f0a6fa&"
import script from "./InputPad.vue?vue&type=script&lang=js&"
export * from "./InputPad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports